// extracted by mini-css-extract-plugin
export var attendance = "Sales-module--attendance--55a80";
export var box = "Sales-module--box--dfbec";
export var boxWrapper = "Sales-module--box-wrapper--34416";
export var form = "Sales-module--form--53a52";
export var formSubmit = "Sales-module--form-submit--5df57";
export var image = "Sales-module--image--4847b";
export var phones = "Sales-module--phones--cceb4";
export var shifts = "Sales-module--shifts--9dbe6";
export var text = "Sales-module--text--789aa";